import React, { useContext } from 'react'
import { UserContext, UserPayload } from '../Context/userContext';
import { Navigate, useLocation } from 'react-router-dom';
import RoundLoader from '../Components/loader/Loader';
import authService from '../utils/authService';
import { AuthStatusEnum } from '../constants/authConstants';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const { authStatus, pendingRedirect } = useContext(UserContext) as UserPayload;
    const location = useLocation();

    if(authStatus === AuthStatusEnum.IDLE || authStatus === AuthStatusEnum.LOADING || pendingRedirect) {
        return <RoundLoader />
    }

    if(authStatus === AuthStatusEnum.UNAUTHENTICATED) {
        authService.saveReturnTo(location.pathname + location.search);
        return <Navigate to="/" />
    }

    return <>{children}</>;
}
